'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = exports.swal = exports.closeIfShow = exports.close = exports.sweetalert = exports.immutableReducer = exports.reducer = undefined;

var _reducer = require('./reducer');

Object.defineProperty(exports, 'reducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducer).default;
  }
});

var _reducerImmutable = require('./reducer-immutable');

Object.defineProperty(exports, 'immutableReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reducerImmutable).default;
  }
});

var _ReduxSweetAlert = require('./ReduxSweetAlert');

var _ReduxSweetAlert2 = _interopRequireDefault(_ReduxSweetAlert);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ReduxSweetAlert2.default;
exports.sweetalert = _actions.sweetalert;
exports.close = _actions.close;
exports.closeIfShow = _actions.closeIfShow;
var swal = exports.swal = _actions.sweetalert;

var actions = exports.actions = {
  sweetalert: _actions.sweetalert,
  swal: swal,
  close: _actions.close,
  closeIfShow: _actions.closeIfShow
};


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-sweetalert/lib/index.js
// module id = ./node_modules/react-redux-sweetalert/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons